import React, { FC } from 'react'

import './PanelBody.scss'

export const PanelBody: FC = ({ children }) => <div className="panel-body">{children}</div>
